var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 0H.812v27.188H28V0Z",
    fill: "#00B67A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m14.406 18.323 4.135-1.048 1.728 5.325-5.863-4.277Zm9.516-6.882h-7.278l-2.238-6.853-2.237 6.853H4.89l5.89 4.248-2.237 6.854 5.89-4.248 3.626-2.606 5.862-4.248Z",
    fill: "#fff"
  })));
};
export default SvgStar;